import { render, staticRenderFns } from "./ActivityOpenQuestionItem.vue?vue&type=template&id=6a9e2c8b&scoped=true&"
import script from "./ActivityOpenQuestionItem.vue?vue&type=script&lang=js&"
export * from "./ActivityOpenQuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityOpenQuestionItem.vue?vue&type=style&index=0&id=6a9e2c8b&lang=scss&scoped=true&"
import style1 from "./ActivityOpenQuestionItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e2c8b",
  null
  
)

export default component.exports